import React, { useCallback, useEffect, useState } from "react";
import { EmblaCarouselType } from "embla-carousel";

import { IconButton, IconButtonProps } from "@mui/material";
import { ArrowSplideLeft, ArrowSplideRight } from "../../../icons";

type UsePrevDetailNextButtonsType = {
  prevBtnDisabled: boolean;
  nextBtnDisabled: boolean;
  onPrevButtonClick: () => void;
  onNextButtonClick: () => void;
};

export const usePrevDetailNextButtons = (
  emblaApi: EmblaCarouselType | undefined
): UsePrevDetailNextButtonsType => {
  const [prevBtnDisabled, setPrevBtnDisabled] = useState(true)
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true)

  const onPrevButtonClick = useCallback(() => {
    if (!emblaApi) return
    emblaApi.scrollPrev()
  }, [emblaApi])

  const onNextButtonClick = useCallback(() => {
    if (!emblaApi) return
    emblaApi.scrollNext()
  }, [emblaApi])

  const onSelect = useCallback((embla: EmblaCarouselType) => {
    setPrevBtnDisabled(!embla.canScrollPrev())
    setNextBtnDisabled(!embla.canScrollNext())
  }, [])

  useEffect(() => {
    if (!emblaApi) return

    onSelect(emblaApi)
    emblaApi.on("reInit", onSelect).on("select", onSelect)
  }, [emblaApi, onSelect])

  return {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  }
}
type PropType = IconButtonProps;

export const PrevDetailButton: React.FC<PropType> = (props) => {
  const { children, ...restProps } = props;

  return (
    <IconButton
    sx={{p: "8px !important"}}
      className="embla__button__detail embla__button--prev"
      type="button"
      {...restProps}
    >
      <ArrowSplideLeft
        sx={{
          width: 13,
          height: 13,
        }}
        htmlColor="#f5f5f7"
      />
    </IconButton>
  );
};

export const NextDetailButton: React.FC<PropType> = (props) => {
  const { children, ...restProps } = props;

  return (
    <IconButton
      className="embla__button__detail embla__button--next"
      type="button"
      {...restProps}
    >
      <ArrowSplideRight
        sx={{
          width: 13,
          height: 13,
        }}
        htmlColor="#f5f5f7"
      />
    </IconButton>
  );
};
